export interface GenericDataMapping {
  title: string;
  value: any; // This should be typed more specifically based on the use case.
  type?: ValueType;
}

export enum ValueType {
  Text = 'text',
  Url = 'url',
}
